export * from './exam-center-page.component';
